import { useCallback } from 'react';

import { useCheckHeader } from 'Src/feature/check/useCheckHeader';
import * as types from 'Src/feature/notification/types';
import { useCurrentOperator } from 'Src/feature/operator/useCurrentOperator';

import { NotificationUI } from './useNotification';

const useIsMyNotification = () => {
  const { currentOperator, employeeId } = useCurrentOperator();
  const checkHeader = useCheckHeader.query.collection();

  const isMyNotification = useCallback((n: NotificationUI) => {
    let
      authReqCreate: NotificationUI<types.AuthorizationRequestCreated> | undefined,
      printJobFail: NotificationUI<types.CheckPrintJobFailure> | undefined,
      s2pCheckPaid: NotificationUI<types.S2PCheckPaid> | undefined,
      safTransaction: NotificationUI<types.CheckPaymentGoodFaithTransaction> | undefined;
    switch (n.type) {
      case 'authorizationRequest':
        if (!currentOperator?.shift?.id) return false;
        authReqCreate = n as NotificationUI<types.AuthorizationRequestCreated>;
        return authReqCreate.data.potentialApproverShiftIds.includes(currentOperator.shift.id);
      case 'printFailure':
        printJobFail = n as NotificationUI<types.CheckPrintJobFailure>;
        return [printJobFail.data.employeeId, checkHeader.data?.map.get(printJobFail.data.checkId)?.employeeId].includes(employeeId);
      case 's2pCheckPaid':
        s2pCheckPaid = n as NotificationUI<types.S2PCheckPaid>;
        return [s2pCheckPaid.data.check.employeeId, checkHeader.data?.map.get(s2pCheckPaid.data.check.id)?.employeeId].includes(employeeId);
      case 'safTransaction':
        safTransaction = n as NotificationUI<types.CheckPaymentGoodFaithTransaction>;
        return [safTransaction.data.employeeId, checkHeader.data?.map.get(safTransaction.data.employeeId)?.employeeId].includes(employeeId);
      default:
        return false;
    }
  }, [currentOperator?.shift?.id, employeeId, checkHeader.data?.map]);

  return { isMyNotification };
};

export { useIsMyNotification };
